import css from 'styled-jsx/css'
import { colors } from '../../styles'

export default css`
.LivePlayer {
  position: relative;
  padding-bottom: 56%;
  margin-bottom: 16px;
  height: 0;
  overflow: hidden;
  min-width: 320px;
  width: 100%;
  background: ${colors.baseBg};
}

.LivePlayer-frame {
  position: absolute;
  border: 0;
  top:0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 16px;
}

.await-check-div {
  height: 70vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.black};
  z-index: 1;
}

}
`
